import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-[#1a1c1b]">
        {/* Removed generic background image as per request */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1c1b] via-[#302f2c]/20 to-[#1a1c1b]"></div>
      </div>

      <div className="container-custom relative z-10 mx-auto px-6 text-center md:text-left">
        <div className="max-w-4xl">
          <h2 className="text-[var(--brand-primary)] font-bold tracking-widest uppercase mb-4 text-sm md:text-base animate-in fade-in slide-in-from-bottom-4 duration-700">
            From Shop Floor to Global Strategy
          </h2>
          <h1 className="brand-display mb-6 animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
            The Asymmetrical <br/> Advantage
          </h1>
          <p className="body-large mb-8 max-w-2xl animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200">
            Strategic visionary dedicated to helping organizations find their "New and Next". 
            Bridging the gap between front of house, back of house, and out of house.
          </p>
          <div className="flex flex-col md:flex-row gap-4 animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <Link to="/contact" className="btn-primary group">
              Talk "Now New Next" <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a href="#about" className="btn-secondary">
              Read My Story
            </a>
          </div>
        </div>
      </div>
      
      {/* Decorative Ribbon */}
      <div className="absolute -bottom-10 -right-20 md:right-0 opacity-20 md:opacity-100 pointer-events-none overflow-hidden w-full h-40">
         <div className="creative-ribbon" style={{bottom: '20%', right: '-10%', width: '150%'}}>
            LEADERSHIP • INNOVATION • TRANSFORMATION • TECHNOLOGY • FUTURE OF WORK
         </div>
      </div>
    </section>
  );
};

export default HeroSection;
